<div class="suif-lead-paragraph">
    Did you forget your password or lose access to your Account ID?
</div>
<app-radio-group
        [(ngModel)]="helpOption"
        [list]="helpOptions"
        code="stateName"
        isRequired
        direction="column" ></app-radio-group>

<div class="button-row">
    <button type="button" class="btn btn-secondary" (click)="goBack()">
        Cancel
    </button>
    <app-wait-button (onClick)="submit()"
                     cssClass="btn btn-verty"
                     [waiting]="submitting"
                     [isDisabled]="!helpOption"
                     label="Continue"></app-wait-button>
</div>
